export const downloadConstants = {
  LOAD_CSV_TICKETS_REQUEST: 'LOAD_CSV_TICKETS_REQUEST',
  LOAD_CSV_TICKETS_SUCCESS: 'LOAD_CSV_TICKETS_SUCCESS',
  LOAD_CSV_TICKETS_ERROR: 'LOAD_CSV_TICKETS_ERROR',
};
